import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/watchlist/importer/watchlistImporterActions';

export default importerReducers(actions);
